import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import CreateMatHelp from "./CreateMatHelp";
import i18next from "i18next";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import i18 from "@mnjsplatform/data/lib/localization/i18";

const matHelpMap = {
    Marriage: {
        Title: "MatHelp_Marriage_Title",
        Instruction: <div style={{textAlign: 'center'}}>{i18next.t("MatHelp_Marriage_Instruction_1")}
            <span style={{color: '#0000FF'}}> {i18next.t("MatHelp_Marriage_Instruction_2")}</span>
            <p>{i18next.t("MatHelp_Marriage_Instruction_3")}</p></div>,
        SuccessMessage: "Request_Sent_To_HR",
        ErrorMessage: "MatHelp_Error_Message",
        ConfirmationText: "MatHelp_Marriage_ConfirmationText",
        ReducerName: "MatHelp_CreateFromPO_Marriage"
    },
    Child: {
        Title: "MatHelp_Child_Title",
        Instruction: <div style={{textAlign: 'center'}}>{i18next.t("MatHelp_Child_Instruction_1")}
            <span style={{color: '#0000FF'}}> {i18next.t("MatHelp_Child_Instruction_2")}</span>
            <p>{i18next.t("MatHelp_Child_Instruction_3")}</p></div>,
        SuccessMessage: "Request_Sent_To_HR",
        ErrorMessage: "MatHelp_Error_Message",
        ConfirmationText: "MatHelp_Child_ConfirmationText",
        ReducerName: "MatHelp_CreateFromPO_Child"
    },
    Burial: {
        Title: "MatHelp_Burial_Title",
        Instruction: <div style={{textAlign: 'center'}}>{i18next.t("MatHelp_Burial_Instruction_1")}
            <span style={{color: '#0000FF'}}> {i18next.t("MatHelp_Burial_Instruction_2")}</span>
            <p>{i18next.t("MatHelp_Burial_Instruction_3")}</p></div>,
        SuccessMessage: "Request_Sent_To_HR",
        ErrorMessage: "MatHelp_Error_Message",
        ConfirmationText: "MatHelp_Burial_ConfirmationText",
        ReducerName: "MatHelp_CreateFromPO_Burial"
    },
    SemiCent: {
        Title: "MatHelp_SemiCent_Title",
        Instruction: <div style={{textAlign: 'center'}}>
            <span style={{color: '#0000FF'}}> {i18next.t("MatHelp_SemiCent_Instruction_2")}</span></div>,
        SuccessMessage: "MatHelp_SemiCent_SuccessText",
        ErrorMessage: "MatHelp_Error_Message",
        ConfirmationText: "MatHelp_SemiCent_ConfirmationText",
        ReducerName: "MatHelp_CreateFromPO_SemiCent"
    },
    LongIll: {
        Title: "MatHelp_LongIll_Title",
        Instruction: null,
        SuccessMessage: "Request_Sent_To_HR",
        ErrorMessage: "MatHelp_Error_Message",
        ConfirmationText: "MatHelp_LongIll_ConfirmationText"
    }
}

class MatHelp extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showInputForm: false,
            selectedTypeId: null
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.MatHelpType_ListRefPO.execute(key));
            await this.props.dispatch(this.props.MatHelp_ListAllForPO.execute(key));
        } catch (e) {
            await this.props.dispatch(errorRaised(e));
        }
    }

    async onRefresh() {
        try {
            let key = {};
            await this.props.dispatch(this.props.MatHelp_ListAllForPO.execute(key));
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    getTypeInfo = (typeId) => ({
        ...matHelpMap[typeId],
        typeId
    });

    createRequest = (e, typeId) => {
        e && e.preventDefault();

        let typeInfo = this.getTypeInfo(typeId);
        if (typeInfo && typeInfo.ConfirmationText && typeInfo.ReducerName) {
            confirm(i18next.t(typeInfo.ConfirmationText), {header: i18next.t("Confirmation")})
                .then(() => {
                    this.setState({showInputForm: true, selectedTypeId: typeId});
                })
                .catch(() => {
                })
        }
    }

    closeRequestForm = () => {
        this.setState({showInputForm: false, selectedTypeId: null}, this.onRefresh);
    }

    renderRow = (r) => {
        let typeId = r.MatHelpTypeId;
        return (
            <div key={typeId} className="my-2">
                <hr/>
                <button className="btn mn-btn-link" onClick={(e) => this.createRequest(e, typeId)}>
                    {r["MatHelpTypeRefName"]}
                </button>
            </div>
        );
    };

    render() {
        return (
            <>
                <PlaceholderWrapper placeholderId="10"
                                    title={<><i
                                        className='fa fa-hand-o-down'/> {i18next.t("MatHelp_Request_Types")}</>}
                                    showSplitterLine={false} canCollapse={true}>
                    {this.props.MatHelpType_ListRefPO.dataTable().map(r => this.renderRow(r))}
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="20"
                                    title={<><i
                                        className='fa fa-file-text-o'/> {i18next.t("MatHelp_Requests")}</>}
                                    showSplitterLine={false} canCollapse={true}>
                    <GridView dataItem={this.props.MatHelp_ListAllForPO} allowPagination={true} readOnly={true}/>
                </PlaceholderWrapper>
                {this.state.showInputForm &&
                    <CreateMatHelp onClose={this.closeRequestForm}
                                   typeInfo={this.getTypeInfo(this.state.selectedTypeId)}/>
                }
            </>
        )
    }
}

MatHelp.propTypes = {
    dispatch: PropTypes.func.isRequired,
    MatHelpType_ListRefPO: PropTypes.object,
    MatHelp_ListAllForPO: PropTypes.object
}

MatHelp.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        MatHelpType_ListRefPO: state.matHelpState.MatHelpType_ListRefPO,
        MatHelp_ListAllForPO: state.matHelpState.MatHelp_ListAllForPO
    }
}

export default connect(mapStateToProps)(MatHelp);